// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InstallationPriceTable_sectionInstallationPriceTable__tgw1l {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
}

.InstallationPriceTable_tableWrapper__D19j5 {
  width: 100%;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.InstallationPriceTable_table__T\\+TrH {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  border-radius: var(--border-radius-lg);
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  max-width: 1110px;
  table-layout: fixed;
}
.InstallationPriceTable_table__T\\+TrH tbody {
    overflow: hidden;
    width: 100%;
}

.InstallationPriceTable_headerName__U1Oo1, .InstallationPriceTable_headerUnit__vL-wc, .InstallationPriceTable_headerPrice__IPzC7 {
  background-color: var(--color-accent-light);
  padding: 16px 20px;
  color: #fff;
  border: 1px solid var(--color-background);
  font-weight: bold;
  font-size: var(--font-size-lg);
}

.InstallationPriceTable_headerName__U1Oo1 {
  text-align: left;
  width: 60%;
}

.InstallationPriceTable_headerUnit__vL-wc {
  text-align: center;
  width: 20%;
}

.InstallationPriceTable_headerPrice__IPzC7 {
  text-align: center;
  width: 20%;
}

.InstallationPriceTable_name__QZFTL {
  padding: 12px 20px;
  border: 1px solid var(--color-background);
  font-size: var(--font-size-md);
  color: var(--color-background);
  text-align: left;
}

.InstallationPriceTable_unit__gJQ5p {
  padding: 12px 20px;
  border: 1px solid var(--color-background);
  font-size: var(--font-size-md);
  color: var(--color-background);
  text-align: center;
}

.InstallationPriceTable_price__DPk8T {
  padding: 12px 20px;
  border: 1px solid var(--color-background);
  font-size: var(--font-size-md);
  color: var(--color-background);
  text-align: center;
  white-space: nowrap;
}

.InstallationPriceTable_table__T\\+TrH tr:nth-child(even) {
  background-color: var(--color-accent-super-light);
}

.InstallationPriceTable_table__T\\+TrH tr:hover {
  background-color: var(--color-accent-super-light-pressed);
}

.InstallationPriceTable_buttonRow__8T\\+C6{
    display: flex;
    align-items: center;
    gap: 15px;
    max-width: 500px;
    flex-direction: column;
    margin-top: 20px;
  }

.InstallationPriceTable_buttonRow__8T\\+C6 p {
  text-align: center;
  margin: 0;
  color: #fff;
}

.InstallationPriceTable_sectionRow__LEBzn {
  background-color: var(--color-accent-super-light);
}

.InstallationPriceTable_sectionName__lhzww {
  padding: 12px 20px;
  font-weight: bold;
  color: var(--color-background);
  text-align: center;
  font-size: var(--font-size-md);
  background-color: var(--color-accent-super-light);
  border: 1px solid var(--color-background);
}`, "",{"version":3,"sources":["webpack://./src/components/Tables/InstallationPriceTable/InstallationPriceTable.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;EAChB,wCAAwC;EACxC,iBAAiB;EACjB,mBAAmB;AACrB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,8BAA8B;EAC9B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;EAClB;;AAEF;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,8BAA8B;EAC9B,iDAAiD;EACjD,yCAAyC;AAC3C","sourcesContent":[".sectionInstallationPriceTable {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 40px;\n}\n\n.tableWrapper {\n  width: 100%;\n  margin: 20px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #fff;\n  border-radius: var(--border-radius-lg);\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  max-width: 1110px;\n  table-layout: fixed;\n}\n.table tbody {\n    overflow: hidden;\n    width: 100%;\n}\n\n.headerName, .headerUnit, .headerPrice {\n  background-color: var(--color-accent-light);\n  padding: 16px 20px;\n  color: #fff;\n  border: 1px solid var(--color-background);\n  font-weight: bold;\n  font-size: var(--font-size-lg);\n}\n\n.headerName {\n  text-align: left;\n  width: 60%;\n}\n\n.headerUnit {\n  text-align: center;\n  width: 20%;\n}\n\n.headerPrice {\n  text-align: center;\n  width: 20%;\n}\n\n.name {\n  padding: 12px 20px;\n  border: 1px solid var(--color-background);\n  font-size: var(--font-size-md);\n  color: var(--color-background);\n  text-align: left;\n}\n\n.unit {\n  padding: 12px 20px;\n  border: 1px solid var(--color-background);\n  font-size: var(--font-size-md);\n  color: var(--color-background);\n  text-align: center;\n}\n\n.price {\n  padding: 12px 20px;\n  border: 1px solid var(--color-background);\n  font-size: var(--font-size-md);\n  color: var(--color-background);\n  text-align: center;\n  white-space: nowrap;\n}\n\n.table tr:nth-child(even) {\n  background-color: var(--color-accent-super-light);\n}\n\n.table tr:hover {\n  background-color: var(--color-accent-super-light-pressed);\n}\n\n.buttonRow{\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    max-width: 500px;\n    flex-direction: column;\n    margin-top: 20px;\n  }\n\n.buttonRow p {\n  text-align: center;\n  margin: 0;\n  color: #fff;\n}\n\n.sectionRow {\n  background-color: var(--color-accent-super-light);\n}\n\n.sectionName {\n  padding: 12px 20px;\n  font-weight: bold;\n  color: var(--color-background);\n  text-align: center;\n  font-size: var(--font-size-md);\n  background-color: var(--color-accent-super-light);\n  border: 1px solid var(--color-background);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionInstallationPriceTable": `InstallationPriceTable_sectionInstallationPriceTable__tgw1l`,
	"tableWrapper": `InstallationPriceTable_tableWrapper__D19j5`,
	"table": `InstallationPriceTable_table__T+TrH`,
	"headerName": `InstallationPriceTable_headerName__U1Oo1`,
	"headerUnit": `InstallationPriceTable_headerUnit__vL-wc`,
	"headerPrice": `InstallationPriceTable_headerPrice__IPzC7`,
	"name": `InstallationPriceTable_name__QZFTL`,
	"unit": `InstallationPriceTable_unit__gJQ5p`,
	"price": `InstallationPriceTable_price__DPk8T`,
	"buttonRow": `InstallationPriceTable_buttonRow__8T+C6`,
	"sectionRow": `InstallationPriceTable_sectionRow__LEBzn`,
	"sectionName": `InstallationPriceTable_sectionName__lhzww`
};
export default ___CSS_LOADER_EXPORT___;
